import type { ComponentType, ReactNode } from 'react';
import type { LucideProps } from 'lucide-react';

type Props = {
  title: string;
  subtitle?: string;
  icon?: ComponentType<LucideProps>;
  action?: ReactNode;
  badge?: ReactNode;
};

export function PageHeader({ title, subtitle, icon: Icon, action, badge }: Props) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3 pb-1">
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-2">
          {Icon ? <Icon className="size-5 text-[var(--color-foreground-muted)]" /> : null}
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          {badge}
        </div>
        {subtitle ? (
          <p className="mt-1 text-sm text-[var(--color-foreground-muted)]">{subtitle}</p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
